import { useQuery } from '@tanstack/react-query';
import { getEdadJugador } from '../../services/jugadorService';

/**
 * Hook para obtener la edad de un jugador por ID y temporada
 * @param {number} idJugador - ID del jugador
 * @param {number} idTemporada - ID de la temporada
 * @param {object} options - Opciones de React Query
 */
export const useJugador = (idJugador, idTemporada, options = {}) => {
  return useQuery({
    queryKey: ['jugador', idJugador, idTemporada],
    queryFn: () => getEdadJugador(idJugador, idTemporada, null),
    enabled: !!(idJugador && idTemporada),
    staleTime: 24 * 60 * 60 * 1000, // 24 horas (edad no cambia frecuentemente)
    ...options,
  });
};

export default useJugador;
